/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Sec_Pg_L7Inputs */

const en_mk_sec_pg_l7 = /** @type {(inputs: Mk_Sec_Pg_L7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`SSO / SAML / LDAP`)
};

const id_mk_sec_pg_l7 = /** @type {(inputs: Mk_Sec_Pg_L7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`SSO / SAML / LDAP`)
};

/**
* | output |
* | --- |
* | "SSO / SAML / LDAP" |
*
* @param {Mk_Sec_Pg_L7Inputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_sec_pg_l7 = /** @type {((inputs?: Mk_Sec_Pg_L7Inputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Sec_Pg_L7Inputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_sec_pg_l7(inputs)
	return en_mk_sec_pg_l7(inputs)
});